export const SET_IMMAPER_FORMDATA = 'SET_IMMAPER_FORMDATA';
export const SET_IMMAPER_DATA = 'SET_IMMAPER_DATA';
